module.exports = __webpack_public_path__ + "static/media/suplements_coming_soon.03c7fd70.png";